import * as Types from '@/types/productivity-schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql-productivity';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type P_TriggerPersonKnowledgeMutationVariables = Types.Exact<{
  personId: Types.Scalars['ID']['input'];
  email: Types.Scalars['String']['input'];
}>;


export type P_TriggerPersonKnowledgeMutation = { triggerPersonKnowledge?: boolean | null };


export const P_TriggerPersonKnowledgeDocument = /*#__PURE__*/ gql`
    mutation p_TriggerPersonKnowledge($personId: ID!, $email: String!) {
  triggerPersonKnowledge(personId: $personId, email: $email)
}
    `;

export function useP_TriggerPersonKnowledgeMutation() {
  return Urql.useMutation<P_TriggerPersonKnowledgeMutation, P_TriggerPersonKnowledgeMutationVariables>(P_TriggerPersonKnowledgeDocument);
};